export default {
  title_text: '客户',
  sidebar_client: '客户管理',
  sidebar_plan: '计划管理',
  sidebar_setting: '设置管理',
  sidebar_info: '客户信息',
  sidebar_tag: '客户标签',
  sidebar_blacklist: '黑名单客户',
  sidebar_saving_rules: '客户保存规则',
  sidebar_contact_plan: '联系计划设置',
  test: 'crm-test321'
}
